import { useFeatureFlags } from './use-feature-flags';

/**
 * Returns true if the given feature flag key is in the active list, false otherwise.
 * Returns false while the flags are loading or if an error occurs (fail-closed).
 *
 * Pass `enabled: false` (e.g. `enabled: isAuthenticated`) to prevent the underlying
 * feature-flags query from firing before auth is established. When disabled, returns
 * `false` immediately (fail-closed). Defaults to `true` so existing callers are unaffected.
 *
 * Derives from `useFeatureFlags()` so no additional network request is made.
 */
export function useIsFeatureFlagActive<T extends string>(flag: T, enabled?: boolean): boolean {
  const { data: activeFlags } = useFeatureFlags(enabled);
  return activeFlags?.includes(flag) ?? false;
}
